import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { AddressOfUse } from "./components/addressOfUse";
import { AddressOfSpain } from "./components/addressOfSpain";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Calculadora } from "./components/calculadora";
import { Asesores } from "./components/asesores";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import Terminos from "./components/Terminos/terminos";
import JsonData from "./data/data.json";
import { BuyAmazon } from "./components/buyAmazon";
import { News } from "./components/news";
import { Questions } from "./components/questions";
import { NewsDetails } from "./components/newsDetails";
import "./App.css";
import Invoices from "./components/Invoices/invoices";
import Shipment from "./components/Instruction/shipment";
import CreateUser from "./components/Instruction/createUser";
import Politicas from "./components/Politicas/politicas";






const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Navigation />
      <Switch>
        <Route exact path="/" render={() => <Header data={landingPageData.Header} />} />
        <Route path="/address-of-use" render={() => <AddressOfUse data={landingPageData.AddresOfUse} />} />
        <Route path="/address-of-spain" render={() => <AddressOfSpain data={landingPageData.AddresOfSpain} />} />
        <Route path="/exemption-amazon" render={() => <BuyAmazon data={landingPageData.Amazon} />} />
        <Route path="/about" render={() => <About data={landingPageData.About} />} />
        <Route path="/news" render={() => <News data={landingPageData.About} />} />
        <Route path="/news-details/:id" render={() => <NewsDetails data={landingPageData.About} />} />
        <Route path="/services" render={() => <Services data={landingPageData.Services} />} />
        <Route path="/gallery" render={() => <Gallery data={landingPageData.Gallery} />} />
        <Route path="/calculadora" render={() => <Calculadora data={landingPageData.Calculadora} />} />
        <Route path="/asesores" render={() => <Asesores data={landingPageData.Asesores} />} />
        <Route path="/contact" render={() => <Contact data={landingPageData.Contact} />} />
        <Route path="/terms" render={() => <Terminos data={landingPageData.Terminos} />} />
        <Route path="/invoices" render={() => <Invoices data={landingPageData.Invoices} />} />
        <Route path="/shipment" render={() => <Shipment data={landingPageData.Invoices} />} />
        <Route path="/account" render={() => <CreateUser data={landingPageData.Invoices} />} />
        <Route path="/questions" render={() => <Questions data={landingPageData.Questions} />} />
        <Route path="/policies" render={() => <Politicas data={landingPageData.Terminos} />} />
      </Switch>
      <Footer />

      {/* WhatsApp botón flotante */}
      <a
        href="https://wa.me/51908855620"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-whatsapp whatsapp-icon"></i>
      </a>
    </Router>
  );
};

export default App;
